'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SimpleHeader = function SimpleHeader(props) {
  return _react2.default.createElement(
    'nav',
    { className: 'pxl-simple-header ' + props.className },
    _react2.default.createElement(
      'a',
      { href: props.linkUrl },
      _react2.default.createElement('img', { src: props.logoUrl, className: 'pxl-logo' })
    )
  );
};

SimpleHeader.propTypes = {
  className: _propTypes2.default.string,
  linkUrl: _propTypes2.default.string,
  logoUrl: _propTypes2.default.string.isRequired
};

SimpleHeader.defaultProps = {
  className: '',
  linkUrl: '/'
};

exports.default = SimpleHeader;